const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  topic: yup.string().min(2, "Minimum of 2 characters expected").required("Topic is required"),
  label: yup.string().min(2, "Minimum of 2 characters expected").required("Post title is required"),
  status: yup.boolean().required("Status is required"),
  post: yup.string().required("Post is required"),
});
const file = yup.object({
  file: yup.mixed().required("File is required"),
});

module.exports = {
  create,
  file,
};
